import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  QuarterlyFeedbackResponse,
  SaveQuarterlyFeedback,
  UpdateQuarterlyFeedback,
  EmployeeInfoUpdatePayload,
  EmployeeTeamUpdatePayload,
  EmployeePerformanceUpdatePayload,
  EmployeeSkillsUpdatePayload
} from '@app/shared/interfaces/contractor-profile';
import { ToasterService } from '@app/shared/services/toaster.service';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { ContractorQuarterly } from '@app/shared/constants/constants';
import { releaseFormData } from './contractor-profile.config';
import { GlobalErrorService } from '@app/shared/services/global-error.service';

@Injectable({
  providedIn: 'root',
})
export class ContractorProfileService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToasterService,
    private errorHandler: GlobalErrorService,
  ) {}

  getQuarterlyFeedback(
    employeeId: string,
    year: string,
    quarter: string,
  ): Observable<QuarterlyFeedbackResponse> {
    return this.http
      .get<QuarterlyFeedbackResponse>(
        `${this.baseUrl}/hiring/contractor-feedback?employeeId=${employeeId}&year=${year}&quarter=${quarter}`,
      )
      .pipe(
        catchError((error) => {
          this.toasterService.showError(
            ContractorQuarterly.failedToLoadFeedback,
            ContractorQuarterly.loadError,
          );
          return throwError(() => error);
        }),
      );
  }

  saveQuarterlyFeedback(
    feedback: SaveQuarterlyFeedback,
  ): Observable<SaveQuarterlyFeedback> {
    return this.http
      .post<SaveQuarterlyFeedback>(
        `${this.baseUrl}/hiring/contractor-feedback`,
        feedback,
      )
      .pipe(
        catchError((error) => {
          this.toasterService.showError(
            ContractorQuarterly.saveError,
            ContractorQuarterly.saveServiceError,
          );
          return throwError(() => error);
        }),
      );
  }

  updateQuarterlyFeedback(
    feedback: UpdateQuarterlyFeedback,
  ): Observable<UpdateQuarterlyFeedback> {
    return this.http
      .put<UpdateQuarterlyFeedback>(
        `${this.baseUrl}/hiring/contractor-feedback`,
        feedback,
      )
      .pipe(
        catchError((error) => {
          this.toasterService.showError(
            ContractorQuarterly.updateError,
            ContractorQuarterly.updateServiceError,
          );
          return throwError(() => error);
        }),
      );
  }
  updateEmployeePerformance(payload: EmployeePerformanceUpdatePayload): Observable<EmployeePerformanceUpdatePayload> {
    return this.http.put<any>(`${this.baseUrl}/hiring/employee-performance`, payload)
      .pipe(catchError((err) => { this.toasterService.showError(ContractorQuarterly.updateError, ContractorQuarterly.updateServiceError); return throwError(()=>err); }));
  }

  updateEmployeeSkills(payload: EmployeeSkillsUpdatePayload): Observable<EmployeeSkillsUpdatePayload> {
    return this.http.put<any>(`${this.baseUrl}/hiring/employee-skills`, payload)
      .pipe(catchError((err) => { this.toasterService.showError(ContractorQuarterly.updateError, ContractorQuarterly.updateServiceError); return throwError(()=>err); }));
  }

    releaseFormData(releaseData: releaseFormData,  employeeId: string,): Observable<releaseFormData> {
      return this.http
        .post<releaseFormData>(
          `${this.baseUrl}/hiring/release-details?employeeId=${employeeId}`,
          releaseData,
        )
        .pipe(
          catchError((error) => {
            return this.errorHandler.logError(error);
          }),
        );
    }
    
}
